// AUTHORITY STATUS
export const GET_AUTHORITY_STATUSES = '/authority-status/query';
export const GET_AUTHORITY_STATUS = '/authority-status/';
export const POST_AUTHORITY_STATUS = '/authority-status/';
export const PUT_AUTHORITY_STATUS = '/authority-status/';
export const DELETE_AUTHORITY_STATUS = '/authority-status/';
